import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IGetPostLoginNotificationsParams {
}

export interface IGetPostLoginNotificationsResult extends IResult {
  contentUrl: string;
}

export class GetPostLoginNotificationsRequest
    extends Request<IGetPostLoginNotificationsParams, IGetPostLoginNotificationsResult> {

  constructor() {
    super('getPostLoginNotifications', {});
  }

}
